<script>
  import { onMount } from "svelte";
  import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Table,
    Button,
    Form,
    FormGroup,
    Label, 
      
  } 
  from "sveltestrap";
  import Breadcrumb from "../../../common/Breadcrumb.svelte";
  import EcommerceOrdersModal from "./EcommerceOrdersModal.svelte";
	

  let dataPage = "";
  async function getData() {
    let location = "es-CL";
    location = await localStorage.getItem("LANGUAGE");
    if (location == "es") {
      location = "es-CL";
    }
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    fetch(
      `https://api.rastros.cl/api/alerts-page?populate=%2A&locale=${location}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        dataPage = result.data;
      })
      .catch((error) => console.log("error al contactar al servicio: ", error));
  }

  onMount(async () => {
    await getData();
  });

  let orderModal = false;
  const setOrderModal = (status) => {
    orderModal = status;
  };
  
  const orders = [
  {
    id: "1",
    orderId: "07 Oct, 2019",
    billingName: "12:34pm",
    orderdate: "DF4534",
    total: "mdi-car-brake-alert orange",
    badgeclass: "success",
    paymentStatus: "Recibido",
    alert: 1
  },
  {
    id: "2",
    orderId: "07 Oct, 2019",
    billingName: "12:34pm",
    orderdate: "DF4534",
    total: "mdi-engine-off-outline red",
    badgeclass: "success",
    paymentStatus: "Recibido",
    alert: 2
  },
  {
    id: "3",
    orderId: "07 Oct, 2019",
    billingName: "12:34pm",
    orderdate: "DF4534",
    total: "mdi-gauge-full blue",
    badgeclass: "success",
    paymentStatus: "Recibido",
    alert: 3
  },
  {
    id: "4",
    orderId: "07 Oct, 2019",
    billingName: "12:34pm",
    orderdate: "DF4534",
    total: "mdi-water-alert yellow",
    badgeclass: "success",
    paymentStatus: "Recibido",
    alert: 4
  },
  {
    id: "5",
    orderId: "07 Oct, 2019",
    billingName: "12:34pm",
    orderdate: "DF4534",
    total: "mdi-check-decagram green",
    badgeclass: "success",
    paymentStatus: "Recibido",
    alert: 5
  },
  
]

let showTooltip = false;

function toggleTooltip() {
  showTooltip = !showTooltip;
}
</script>
<style>
.icono {
    font-size: 24px;
    display: flex;
    justify-content: center; /* Centrado horizontal */
    align-items: center; /* Centrado vertical */
    height: 8vh;
     }

     #tooltipContainer {
    position: relative;
    display: inline-block;
    /* Add your preferred styles for the tooltip container */
  }

  #tooltipText {
    visibility: hidden;
    width: 120px;
    background-color: #555;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    left: 50%;
    margin-left: -60px;
    /* Add your preferred styles for the tooltip text */
  }

  #tooltipContainer:hover #tooltipText {
    visibility: visible;
  }
  .green {
    color: #00CC82;
  }
  .orange {
    color: #FF9900;
  }
  .red{
    color:#EE1717;
  }
  .yellow{
    color:#FFE600;
  }
  .blue{
    color:#002BF8;
  }
</style>

<EcommerceOrdersModal
  show={orderModal}
  onCloseClick={() => setOrderModal(false)}
/>

<div class="page-content">
  <Container fluid>
    <Breadcrumb title="Alertas" breadcrumbItem={dataPage.title} />

    <Row>
      <div class="col-12">
        <Card>
          <CardBody>
            <Form>
              <Row>
                <h4>{dataPage.filterLabel} :</h4>
                <Col sm="6" class="col-xl">
                  <FormGroup class="mt-3 mb-0">
                    <Label>{dataPage.dateLabel} :</Label>
                    <input
                      type="date"
                      class="form-control"
                      id="orderid-input"
                      placeholder="Select date"
                      value=""
                    />
                  </FormGroup>
                </Col>
    
                <Col sm="6" class="col-xl">
                  <FormGroup class="mt-3 mb-0">
                    <Label>{dataPage.tankLabel} :</Label>
                    <select class="form-control select2-search-disable">
                      <input
                      type="date"
                      class="form-control"
                      id="orderid-input"
                      placeholder="/"
                      value=""
                    />
                    
                    </select>
                  </FormGroup>
                </Col>
    
                <Col sm="6" class="col-xl">
                  <FormGroup class="mt-3 mb-0">
                    <Label>{dataPage.stateLabel} :</Label>
                    <select class="form-control select2-search-disable">
                      <option value="BU" defaultValue> {dataPage.alertTypePlaceholder}  </option>
                      <option value="ETH">Recibida</option>
                      <option value="ETH">No enviado</option>
                      <option value="ETH">Recepcionado</option>
                    </select>
                  

                  </FormGroup>
                </Col>

                <Col sm="6" class="col-xl">
                  <FormGroup class="mt-3 mb-0">
                    <!--Label>{dataPage.alertTypeLabel} :</Label-->
                  
                    
                  </FormGroup>
                </Col>
                <Col sm="6" class="col-xl align-self-end">
                  <div class="mb-3 text-end">
                    <Button type="button" color="primary" class="w-md">
                      {dataPage.filterButton}
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>

            <div class="table-responsive">
              <Table class="align-middle table-nowrap table-check">
                <thead class="table-light">
                  <tr>
                    <th style="width: 20px;" class="align-middle">
                      <div class="form-check font-size-16">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="checkAll"
                        />
                        <label class="form-check-label" for="checkAll" />
                      </div>
                    </th>
                    <th class="align-middle">{dataPage.dateLabel}</th>
                    <th class="align-middle">{dataPage.hourLabel}</th>
                    <th class="align-middle">{dataPage.tankLabel}</th>
                    <th class="align-middle">{dataPage.alertTypeLabel}</th>
                    <th class="align-middle">{dataPage.stateLabel}</th>
                    <th class="align-middle">{dataPage.detailLabel}</th>
                 
                  </tr>
                </thead>
                <tbody>
                  {#each orders as order}
                    <tr>
                      <td>
                        <div class="form-check font-size-16">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="orderidcheck01"
                          />
                          <label
                            class="form-check-label"
                            for="orderidcheck01"
                          />
                        </div>
                      </td>
                      <td
                        ><a href="/" class="text-body fw-bold"
                          >{order.orderId}</a
                        >
                      </td>
                      <td>{order.billingName}</td>
                      <td>
                        {order.orderdate}
                      </td>
                      <td>

                        <!-- svelte-ignore a11y-mouse-events-have-key-events -->
                        <div id="tooltipContainer" on:mouseover={toggleTooltip} on:mouseleave={toggleTooltip}>
                          <i class=" icono mdi {order.total}" ></i>
                    
                          {#if (showTooltip && order.alert == 1) }
                            <span id="tooltipText">Traba</span>
                          {/if}
                          {#if (showTooltip && order.alert == 2) }
                          <span id="tooltipText">Valvula atascada</span>
                        {/if}
                        {#if (showTooltip && order.alert == 3) }
                        <span id="tooltipText">Presión diferente</span>
                      {/if}
                      {#if (showTooltip && order.alert == 4) }
                      <span id="tooltipText">Medidor de flujo</span>
                    {/if}
                    {#if (showTooltip && order.alert == 5) }
                    <span id="tooltipText">Sin alertas</span>
                  {/if}
                        </div>

                      
                        

                      </td>
                      <td>
                        <span
                          class={"badge badge-pill font-size-12 badge-soft-" +
                            order.badgeclass}>{order.paymentStatus}</span
                        >
                      </td>
                     
                      <td>
                        <!-- Button trigger modal -->
                        <Button
                          type="button"
                          color="primary"
                          class="btn btn-primary btn-sm btn-rounded"
                          on:click={setOrderModal}
                        >
                          {dataPage.detailLabel}
                        </Button>
                      </td>
                     
                    </tr>
                  {/each}
                </tbody>
              </Table>
            </div>
            <ul class="pagination pagination-rounded justify-content-end mb-2">
              <li class="page-item disabled">
                <a class="page-link" href="/" aria-label="Previous">
                  <i class="mdi mdi-chevron-left" />
                </a>
              </li>
              <li class="page-item active">
                <a class="page-link" href="/">1</a>
              </li>
              <li class="page-item"><a class="page-link" href="/">2</a></li>
              <li class="page-item"><a class="page-link" href="/">3</a></li>
              <li class="page-item"><a class="page-link" href="/">4</a></li>
              <li class="page-item"><a class="page-link" href="/">5</a></li>
              <li class="page-item">
                <a class="page-link" href="/" aria-label="Next">
                  <i class="mdi mdi-chevron-right" />
                </a>
              </li>
            </ul>
          </CardBody>
        </Card>
      </div>
    </Row>
  </Container>
</div>

